import routes from '@/data/routesWithoutDefaultPath';
import fullMenu from '@/data/menu';
import store from '@/store';

const firstRoute = menu => {
  if (menu && menu.length > 0) {
    if (menu[0].group) {
      return firstRoute(menu[0].children);
    }
    return menu[0].to;
  }
  return null;
};

// eslint-disable-next-line no-restricted-syntax
for (const [category, routesArray] of Object.entries(routes)) {
  routesArray.push({
    name: category,
    path: '',
    beforeEnter: (to, from, next) => {
      const filteredMenu = store.getters.filteredMenu(fullMenu[category]);
      const route = firstRoute(filteredMenu) || { name: 'landing' };
      next(route);
    },
  });
}

export default routes;
